import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'

import { SigningType, SmsVerifyResponse } from '../../../constants/enums'
import { SmsSendResponse } from '../../../types'

export interface Signing {
  didSendFirstSms: boolean
  type?: SigningType
  smsSendResponse: SmsSendResponse
  verificationCode?: SmsVerifyResponse
}

export type SigningState = ImmutableGenericType<Signing>

export const initialState: SigningState = Immutable({
  didSendFirstSms: false,
  type: undefined,
  smsSendResponse: { nextAttemptAvailable: false, sent: false },
  verificationCode: undefined,
})
